export default __webpack_public_path__ + "media/images/socials-instagram-7c46eadc4073de9540ac0c4aa0cbf8c8.svg";